/**
 * `validateSearch` of `/approvals`: the notice that asks an agent to decide an approval
 * (`approval_requested`) carries the id of it, and the bandeja opens that approval's drawer straight
 * away, the same mechanism `/requests` has for a request (`requestsSearchSchema`). Opening it only
 * shows the approval: deciding still takes a button.
 */
export interface ApprovalsSearch {
  approvalRequestId?: string;
}

export function approvalsSearchSchema(search: Record<string, unknown>): ApprovalsSearch {
  const approvalRequestId = search['approvalRequestId'];
  return typeof approvalRequestId === 'string' && approvalRequestId.length > 0
    ? { approvalRequestId }
    : {};
}
